/**
 * @Author: zachalam
 * @Date:   2017-03-15T16:16:05-07:00
 * @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T17:18:54-07:00
 */

import React, { Component } from 'react';

import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';

import Container from '../../blocks/Container';
import ResultList from '../../blocks/ResultList';
import Button from '../../blocks/Button';
import Title from '../../common/Title';
import Header from '../../blocks/Header';
import BlankSlate from '../../blocks/BlankSlate';
import InputGroup from '../../blocks/InputGroup';
import TextInput from '../../common/TextInput';
import BlockedUser from './BlockedUser';
import isEmpty from 'lodash/isEmpty';
import { borders } from '../../../style';

const blockList = (blocked, isFetching) => {
  // loop through each  item.
  
  if(!isFetching && isEmpty(blocked)) {
    return (
      <BlankSlate title={'You haven\'t blocked anyone'} message='' />
    );
  } else {
    var BlockList = Object.keys(blocked).map((key) => {
      try {
        let block = blocked[key];

        let account = block.to_account.data
        let profile = block.to_account.data.profile.data

        return (
          <BlockedUser
            avatar={profile.avatar.data.urls.thumbs}
            title={account.username}
            age={profile.age}
            city={profile.city}
            region={profile.region}
            country={profile.country}
            description={profile.description}
            key={key}
          />
        );
      } catch(e) {
        return null;
      }
    })

    return (
      <ResultList>
        {BlockList}
      </ResultList>
    );
  }
}

class Blocked extends Component {
  render() {
    const {
      blocked,
      moreExists,
      loadMore
    } = this.props;

    return (
      <div>
        <Container fullWidth>
          <Header>
            <Title>Blocked accounts</Title>
          </Header>
          {blockList(blocked.items, blocked.isFetching)}
          <ReactPlaceholder
            type='media'
            ready={!blocked.isFetching}
            rows={3}
            showLoadingAnimation
            style={{backgroundColor: 'white', marginTop: '10px', border: borders.DEFAULT, padding: '16px'}}
          >
            {
              moreExists &&
                <Button fit variant="link" onClick={() => {loadMore()}}> Load More </Button>
            }
          </ReactPlaceholder>
        </Container>
      </div>
    );
  }
}

export default Blocked;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Blocked.jsx